import { Injectable } from '@angular/core';
import { CustomerSocketService } from '@events/customer/customer-socket.service';
import { ChangeOperationCollectionEventI } from '@interfaces/change-operation-collection-event.interface';
import { BehaviorSubject } from 'rxjs';
import { TeamsI } from '@interfaces/teams.interface';

@Injectable({
  providedIn: 'root',
})
export class TeamsSocketService {
  private eventName = 'teams-change';
  private changeSubject = new BehaviorSubject<ChangeOperationCollectionEventI<TeamsI> | null>(null);
  public change$ = this.changeSubject.asObservable();
  constructor(private socketService: CustomerSocketService) {}
  public init() {
    this.socketService.init();
    this.socketService?.socket?.on(this.eventName, (payload: ChangeOperationCollectionEventI<TeamsI>) => {
      this.changeSubject.next(payload);
    });
  }
}
